export default (props) => {
	if (props.device === 'mobile') {
		return (
			<iframe className="na" frameBorder="0" scrolling="no" width="100%" height="100%"
					sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
					src="//a.o333o.com/api/spots/239915?p=1"/>
		)
	}
	return (
		<iframe className="na" frameBorder="0" scrolling="no" width="100%" height="100%"
		        sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
		        src="//a.o333o.com/api/spots/239914?p=1" />
	)
}



// WEBPACK FOOTER //
// components/ads/Native.js